export enum InventoryRecordType {
  IN = 'IN',
  OUT = 'OUT',
}
